import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { WebAddresses } from '../app.config';
import { globalUser } from '../helpers/globalFields';
import { ApiResponse } from '../interfaces/api-response';
import { ActiveFilter } from '../interfaces/active-filter';


@Injectable({ providedIn: 'root' })
export class UserService {
  private url = WebAddresses.TicketAuthorisation;

  constructor(private http: HttpClient) {}

  getTableFilters(): Observable<Record<string, ActiveFilter[]>> {
    return this.http
      .get<ApiResponse>(`${this.url}/me/filters`, {
        headers: globalUser.getHeaders(),
      })
      .pipe(map((r) => (r.data as Record<string, ActiveFilter[]>) ?? {}));
  }

  saveTableFilters(tableName: string, filters: ActiveFilter[]): Observable<any> {
    return this.http.patch(
      `${this.url}/me/filters`,
      { tableName, filters },
      { headers: globalUser.getHeaders() },
    );
  }
}